import { api } from "../api";

// Types para notificações
export type NotificationType = 
  | 'PROJECT_ASSIGNED'
  | 'PAYMENT_RECEIVED'
  | 'PAYMENT_OVERDUE'
  | 'PROJECT_AUTO_CREATED'
  | 'STAGE_CHANGED'
  | 'COMMENT_ADDED'
  | 'COMMENT_MENTION'
  | 'INTEGRATOR_REQUEST_CREATED';

export type NotificationPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';

export interface Notification {
  id: number;
  userId: number;
  type: NotificationType;
  title: string;
  message: string;
  entityType?: string;
  entityId?: number;
  isRead: boolean;
  priority: NotificationPriority;
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationQueryParams {
  limit?: number;
  offset?: number;
  onlyUnread?: boolean;
  types?: NotificationType[];
}

export interface UnreadCountResponse {
  count: number;
}

/**
 * API service para gerenciar notificações
 * Seguindo padrão arquitetural do projeto JBE Engenharia
 */

// Listar notificações do usuário
export const getUserNotifications = async (params?: NotificationQueryParams) => {
  const url = "/notifications";
  const queryString = params ? new URLSearchParams({
    ...(params.limit && { limit: params.limit.toString() }),
    ...(params.offset && { offset: params.offset.toString() }),
    ...(params.onlyUnread && { onlyUnread: params.onlyUnread.toString() }),
    ...(params.types && { types: params.types.join(',') })
  }).toString() : '';
  
  return await api.get<Notification[]>(`${url}${queryString ? `?${queryString}` : ''}`);
};

// Contar notificações não lidas
export const getUnreadNotificationsCount = async () => {
  const url = "/notifications/unread-count";
  return await api.get<UnreadCountResponse>(url);
};

// Atualizar status de leitura da notificação
export const updateNotificationReadStatus = async (notificationId: number, action: 'read' | 'unread') => {
  const url = `/notifications/${notificationId}/status`;
  return await api.put(url, { action });
};

// Marcar notificação como lida (wrapper para compatibilidade)
export const markNotificationAsRead = async (notificationId: number) => {
  return await updateNotificationReadStatus(notificationId, 'read');
};

// Marcar notificação como não lida (wrapper para compatibilidade)
export const markNotificationAsUnread = async (notificationId: number) => {
  return await updateNotificationReadStatus(notificationId, 'unread');
};

// Marcar todas as notificações como lidas
export const markAllNotificationsAsRead = async () => {
  const url = "/notifications/mark-all-read";
  return await api.put(url);
};

// Deletar notificação
export const deleteNotification = async (notificationId: number) => {
  const url = `/notifications/${notificationId}`;
  return await api.delete(url);
};
